import { observable } from "mobx";

export const textPreviewMode = observable.box(false);
